const AMPLIFY_BUNDLE_ATC_SELECTOR = '[data-amplify-bundle-atc-button]';
const LOADING_CLASS = 'loading';
const FALLBACK_TIMEOUT = 3000;
const SIZE_OPTION_SELECTOR = '.picky-option[data-option-name="Size"]';
const SIZE_ENHANCED_ATTR = 'data-amplify-size-pills';
const SIZE_PILLS_CLASS = 'amplify-bundle-product__size-pills';
const SIZE_PILL_CLASS = 'amplify-bundle-product__size-pill';
const SIZE_PILL_SELECTED_CLASS = 'amplify-bundle-product__size-pill--selected';
const FIT_LINK_SELECTOR = '.amplify-bundle-product__fit-link';
const FIT_LINK_BOUND_ATTR = 'data-amplify-fit-bound';
const PRODUCT_DESCRIPTION_SELECTOR = '#product-description';
const SIZE_SLIDER_INPUT_SELECTOR =
  '.size_option_input .size_slider input[type="radio"]';
const STICKY_ATC_SELECTOR = '#btn-add';
const STICKY_ATC_DISABLED_CLASS = 'amplify-bundle-sticky-disabled';
const MAIN_ATC_FALLBACK_SELECTOR = '.product-form__submit[name="add"]';

let syncingSizeToTheme = false;

const isSelectedSizeUnavailable = () => {
  const mainAtc =
    document.querySelector(AMPLIFY_BUNDLE_ATC_SELECTOR) ||
    document.querySelector(MAIN_ATC_FALLBACK_SELECTOR);
  if (!mainAtc) return false;
  if (mainAtc.hasAttribute('disabled')) return true;
  return getComputedStyle(mainAtc).display === 'none';
};

const syncStickyAtcState = () => {
  const stickyBtn = document.querySelector(STICKY_ATC_SELECTOR);
  if (!stickyBtn) return;
  stickyBtn.classList.toggle(
    STICKY_ATC_DISABLED_CLASS,
    isSelectedSizeUnavailable()
  );
};

const setRadioChecked = (input, checked) => {
  const setter = Object.getOwnPropertyDescriptor(
    HTMLInputElement.prototype,
    'checked'
  )?.set;
  if (setter) {
    setter.call(input, checked);
  } else {
    input.checked = checked;
  }
};

const syncSizeToTheme = value => {
  if (!value || syncingSizeToTheme) return;

  const input = document.querySelector(
    `${SIZE_SLIDER_INPUT_SELECTOR}[value="${CSS.escape(value)}"]`
  );
  if (!input || input.checked) return;

  syncingSizeToTheme = true;
  setRadioChecked(input, true);
  input.dispatchEvent(new Event('change', { bubbles: true }));
  syncingSizeToTheme = false;
};

const atcButton = document.querySelector(AMPLIFY_BUNDLE_ATC_SELECTOR);

if (atcButton) {
  let fallbackTimer = null;
  const spinner = atcButton.querySelector('.loading-overlay__spinner');

  const clearLoading = () => {
    atcButton.classList.remove(LOADING_CLASS);
    if (spinner) spinner.classList.add('hidden');
    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }
  };

  const startLoading = () => {
    clearLoading();
    atcButton.classList.add(LOADING_CLASS);
    if (spinner) spinner.classList.remove('hidden');
    fallbackTimer = setTimeout(clearLoading, FALLBACK_TIMEOUT);
  };

  // Both this script and product-form.js manage loading state on the same button.
  // This is safe because defer scripts execute in DOM order — product-form.js
  // appears before amplify-bundle-product.js in the document, so its form.submit
  // handler registers first. If that order ever changes, startLoading will fire
  // before product-form.js can check for the loading class, blocking the cart call.
  const form = atcButton.closest('form');
  if (form) {
    form.addEventListener('submit', startLoading);
  } else {
    atcButton.addEventListener('click', () => setTimeout(startLoading, 0));
  }

  new MutationObserver(() => {
    if (document.body.classList.contains('slide-cart')) clearLoading();
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
}

const hideFitOptionIfEmpty = () => {
  const fitOptions = document.querySelectorAll(
    '.picky-option[data-option-name="Fit"]'
  );
  fitOptions.forEach(fitOption => {
    const select = fitOption.querySelector('select');
    const hasRealOptions =
      select &&
      Array.from(select.options).some(opt => !opt.disabled && opt.value !== '');
    if (!hasRealOptions && fitOption.style.display !== 'none') {
      fitOption.style.display = 'none';
    }
  });
};

const renderSizePills = (select, list) => {
  const options = Array.from(select.options).filter(
    option => option.value !== ''
  );

  list.replaceChildren();

  options.forEach(option => {
    const pill = document.createElement('button');
    pill.type = 'button';
    pill.className = SIZE_PILL_CLASS;
    pill.textContent = option.textContent.trim();
    pill.disabled = option.disabled;
    pill.setAttribute('role', 'option');

    if (option.selected) {
      pill.classList.add(SIZE_PILL_SELECTED_CLASS);
      pill.setAttribute('aria-selected', 'true');
    }

    pill.addEventListener('click', () => {
      if (option.disabled || select.value === option.value) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
    });

    list.appendChild(pill);
  });
};

const bindFitLink = () => {
  const fitLink = document.querySelector(FIT_LINK_SELECTOR);
  if (!fitLink || fitLink.getAttribute(FIT_LINK_BOUND_ATTR) === 'true') return;
  fitLink.setAttribute(FIT_LINK_BOUND_ATTR, 'true');

  fitLink.addEventListener('click', event => {
    const target = document.querySelector(PRODUCT_DESCRIPTION_SELECTOR);
    if (!target) return;

    event.preventDefault();

    const headerOffset = window.innerWidth >= 1024 ? 120 : 44;
    const offsetTop =
      target.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'custom_event',
      event_name: 'fit_description_click',
      parameter: ''
    });

    if (window.innerWidth < 1024) {
      const details = target.querySelector('details.description');
      if (details) details.open = true;
    }
  });
};

const enhanceSizeOption = sizeOption => {
  if (sizeOption.getAttribute(SIZE_ENHANCED_ATTR) === 'true') return;

  const select = sizeOption.querySelector('select');
  if (!select || !select.options.length) return;

  sizeOption.setAttribute(SIZE_ENHANCED_ATTR, 'true');

  const list = document.createElement('div');
  list.className = SIZE_PILLS_CLASS;
  list.setAttribute('role', 'listbox');
  sizeOption.appendChild(list);

  const sync = () => {
    renderSizePills(select, list);
    syncSizeToTheme(select.value);
  };
  sync();

  select.addEventListener('change', sync);
  new MutationObserver(sync).observe(select, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'selected']
  });
};

const enhanceSizeOptions = () => {
  document.querySelectorAll(SIZE_OPTION_SELECTOR).forEach(enhanceSizeOption);
};

let syncScheduled = false;
const scheduleWidgetSync = () => {
  if (syncScheduled) return;
  syncScheduled = true;
  requestAnimationFrame(() => {
    syncScheduled = false;
    enhanceSizeOptions();
    hideFitOptionIfEmpty();
    bindFitLink();
    syncStickyAtcState();
  });
};

new MutationObserver(scheduleWidgetSync).observe(document.body, {
  childList: true,
  subtree: true
});

const mainAtcButton =
  document.querySelector(AMPLIFY_BUNDLE_ATC_SELECTOR) ||
  document.querySelector(MAIN_ATC_FALLBACK_SELECTOR);
if (mainAtcButton) {
  new MutationObserver(syncStickyAtcState).observe(mainAtcButton, {
    attributes: true,
    attributeFilter: ['disabled', 'style', 'class']
  });
}

scheduleWidgetSync();
